export default {
  premiumPrice: 9.99,
  defaultTrialPeriodDays: 14
}
